import React from "react";
import Routes from "./routes/Routes";
import AuthBootstrap from "./stores/AuthBootstrap";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { queryClient } from "./config/queryClient";
import "./App.css";
// import ThemeComponent from "./components/ThemeComponent/ThemeComponent";

function App() {
    // replace console.* for disable log on production
    if (process.env.NODE_ENV === "production") {
        console.log = () => {};
        console.error = () => {};
        console.debug = () => {};
    }

    return (
        <QueryClientProvider client={queryClient}>
            <AuthBootstrap>
                {/* <ThemeComponent> */}
                <Routes />
                {/* </ThemeComponent> */}
            </AuthBootstrap>
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </QueryClientProvider>
    );
}

export default App;
